import { AppError, describeError, errorInfoSync, formatDetails, mapCommonError, type FriendlyError } from '@antreja/ui/errors';

export type { FriendlyError } from '@antreja/ui/errors';

/**
 * Portaal-foutvertaling. Supabase/Edge/netwerkfouten → Nederlandse melding + volgende stap (gedeeld met de app).
 * Een gewone `Error` die we zelf gooien (validatie, demo-repository) heeft al een Nederlandse tekst; die tonen we
 * dan als titel. Ruwe Engelse tekst van buiten komt alleen in de technische details.
 */
export function friendlyError(err: unknown, fallbackTitle?: string): FriendlyError {
  const info = errorInfoSync(err);
  const mapped = mapCommonError(info);
  if (mapped) return mapped;
  const ownDutch = err instanceof Error && !(err instanceof AppError) && err.name === 'Error' && !('code' in err) && !('status' in err);
  if (ownDutch) return { kind: 'invalid_input', title: err.message, hint: '', retryable: false, details: formatDetails(info) };
  return describeError(err, { fallbackTitle });
}

/** Eén regel (veldfout, toast). */
export function errorText(err: unknown, fallbackTitle?: string): string {
  const f = friendlyError(err, fallbackTitle);
  return f.hint ? `${f.title} ${f.hint}` : f.title;
}
